import Cookies from 'js-cookie'

const reduceReserveCartResponse = ({
  data,
  sessionId,
  customerNumber,
  agentNumber,
  successRedirect,
  failRedirect,
  paymentData,
  email,
  calculateOnlyGuarantees,
  isModify,
  cartId,
}) => {
  try {
    const addKeyedValue = (key, value) => {
      const preload = []
      if (typeof value === 'undefined') {
        return null
      }
      if (typeof value === 'object' && Array.isArray(value)) {
        value.forEach((val, idx) => {
          if (typeof val === 'object') {
            Object.keys(val).forEach(item => {
              const push = {
                key: `${key}[${idx}][${item}]`,
                value: val[item],
              }
              preload.push(push)
            })
          }
        })
        return preload
      }
      if (typeof value === 'function') {
        return null
      }
      return {
        key,
        value,
      }
    }

    const preloadKeyed = []

    const itineraryId = data?.id

    const preloadData =
      data?.guaranteesAccepted?.find(
        guarentee => guarentee.guaranteeAcceptedViewExtensions?.preload,
      )?.guaranteeAcceptedViewExtensions?.preload || null

    if (preloadData) {
      Object.entries(preloadData).forEach(([key, value]) => {
        const pushKeyed = addKeyedValue(key, value)
        if (pushKeyed !== null) {
          if (Array.isArray(pushKeyed)) {
            pushKeyed.forEach(pushKey => {
              preloadKeyed.push(pushKey)
            })
          } else {
            preloadKeyed.push(pushKeyed)
          }
        }
      })
      if (customerNumber) {
        preloadKeyed.push({
          key: 'customerNumber',
          value: customerNumber,
        })
      }
      if (agentNumber) {
        preloadKeyed.push({
          key: 'agentNumber',
          value: agentNumber,
        })
      }
      if (email) {
        preloadKeyed.push({
          key: 'email',
          value: email,
        })
      }

      ;(calculateOnlyGuarantees || []).forEach((guarantee, index) => {
        const suffix = index === 0 ? '' : index + 1
        const typeCode = guarantee?.guaranteeTypeCode
        const quantity = guarantee?.loyaltyRedemption?.redemptionQuantity
        const seriesCode = guarantee?.paymentCards?.[0]?.seriesCode
        if (typeCode) {
          preloadKeyed.push({
            key: `guaranteeTypeCode${suffix}`,
            value: typeCode,
          })
        }
        if (quantity) {
          preloadKeyed.push({
            key: `redemptionQuantity${suffix}`,
            value: quantity,
          })
        }
        if (seriesCode) {
          preloadKeyed.push({
            key: `travelCardPin${suffix}`,
            value: seriesCode,
          })
        }
      })
      const awcToken = Cookies.get('awc')
      if (awcToken) {
        preloadKeyed.push({
          key: 'awcToken',
          value: awcToken,
        })
      }
      if (isModify) {
        preloadKeyed.push({
          key: 'modify',
          value: true,
        })
      }
      if (cartId) {
        preloadKeyed.push({
          key: 'cartId',
          value: cartId,
        })
      }
      if (paymentData.paymentOption === 'paymentPlan') {
        preloadKeyed.push({
          key: 'paymentPlan',
          value: true,
        })
      }
    }
    const ferryId =
      data?.itineraryInfo?.reservationItems?.find(item => !!item.ferry)?.ferry
        ?.ferryId || 'rf'
    return {
      ekashu: preloadKeyed?.length
        ? [
            ...preloadKeyed,
            {
              key: 'redirectUrl',
              value: `${successRedirect}?itineraryId=${itineraryId}&sessionId=${sessionId}${
                isModify ? '&modified=true&paymentSuccess=true' : ''
              }`,
            },
            {
              key: 'redirectFailUrl',
              value: `${failRedirect}?itineraryId=${itineraryId}&sessionId=${sessionId}&paymentFailed=true${
                isModify ? '&modified=true&paymentSuccess=false' : ''
              }`,
            },
            { key: 'sessionId', value: sessionId },
            { key: 'orderKey', value: new Date().getTime() },
            { key: 'ferryId', value: ferryId },
            { key: 'saveCard', value: Boolean(paymentData?.saveCard) },
          ]
        : null,
    }
  } catch (err) {
    console.warn(err)
    throw new Error(err?.message || 'Error reducing response')
  }
}

export default reduceReserveCartResponse
